import { Calendar } from 'lucide-react';
import { motion } from 'motion/react';
import { useCalendarContext } from '@/components/calendar/context';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/calendar/components/button/button-v1.css';
import '@/components/calendar/components/button/button-v2.css';

export default function Button() {
  const { open, onCalendarButton } = useCalendarContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  return (
    <motion.button
      data-css-version={cssVersion}
      type='button'
      disabled={open}
      className='calendar-button'
      whileTap={{ scale: 1.125 }}
      onClick={() => onCalendarButton()}
    >
      <Calendar />
    </motion.button>
  );
}
